import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Recommendations from '@bibliocommons/recommendations';
import { FORMATS_WHITELIST } from '../constants/RecommendationConstants';
import RecommendationActions from '../actions/RecommendationActions';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

export function RecommendationsContainer({ zeroResults, loaded, item, recommendations, type, supportedRecommendationServices, recommendationActions }) {
  if (supportedRecommendationServices.isEmpty()) return null;
  if (!item) return null;
  return (<Recommendations
    recommendations={recommendations}
    type={type}
    loaded={loaded}
    zeroResults={zeroResults}
    getRecommendations={recommendationActions.getRecommendations}
    itemId={item.get('id')} itemStatus={item.getIn(['availability', 'status'])}
    itemFormat={item.getIn(['briefInfo', 'format'])} />);
}

RecommendationsContainer.displayName = 'RecommendationsContainer';
RecommendationsContainer.propTypes = {
  item: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    briefInfo: ImmutablePropTypes.mapContains({
      format: PropTypes.string
    }),
    availability: ImmutablePropTypes.mapContains({
      status: PropTypes.string
    })
  }),
  loaded: PropTypes.bool,
  recommendationActions: PropTypes.objectOf(PropTypes.func),
  supportedRecommendationServices: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  recommendations: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  type: PropTypes.string,
  zeroResults: PropTypes.bool
};

// Find the first item that is of a valid format and is unavailable
const findItemForRecommendation = (manifestations) =>
   manifestations.find(manifestation => FORMATS_WHITELIST.includes(manifestation.getIn(['briefInfo', 'format'])) && manifestation.getIn(['availability', 'status']) === 'UNAVAILABLE');

const mapStateToProps = (state, ownProps) => {
  const selectedItem = findItemForRecommendation(ownProps.manifestations);
  const filteredRecommendationServices = currentLibrarySelector(state)
          .get('supportedRecommendationServices', Immutable.List())
          .filter(service => service.get('serviceName') !== 'bookish');
  const itemRecommendations = selectedItem ? state.getIn(['recommendation', selectedItem.get('id')], Immutable.Map()) : Immutable.Map();

  return {
    item: selectedItem,
    recommendations: itemRecommendations.recommendations,
    type: itemRecommendations.type,
    loaded: itemRecommendations.loaded,
    zeroResults: itemRecommendations.zeroResults,
    supportedRecommendationServices: filteredRecommendationServices
  };
};

const mapDispatchToProps = dispatch => ({
  recommendationActions: bindActionCreators(RecommendationActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationsContainer);



// WEBPACK FOOTER //
// ./app/containers/RecommendationsContainer.jsx